import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import type { StringArrayPayload } from './config/arrayPayload.types.ts';
import { storeNames } from './config/config.type.ts';

interface BargeControlStore {
  visibleDevices: string[];
  setVisibleDevices: (devices: StringArrayPayload) => void;
  showAllDevices: () => void;
  hideAllDevices: () => void;
}
export enum BargeControlDevice {
  Gio = 'gio',
  Tanks = 'tanks',
  BilgePumps = 'bilgePumps',
  Generators = 'generators',
  Silos = 'silos',
}
const initialState = {
  visibleDevices: Object.values(BargeControlDevice) as string[],
};

export const useBargeControlStorage = create(
  persist<BargeControlStore>(
    set => ({
      ...initialState,

      setVisibleDevices: devicesOrUpdater =>
        set(state => ({
          visibleDevices:
            typeof devicesOrUpdater === 'function'
              ? devicesOrUpdater(state.visibleDevices)
              : devicesOrUpdater,
        })),
      showAllDevices: () => set(() => ({ visibleDevices: Object.values(BargeControlDevice) })),
      hideAllDevices: () => set(() => ({ visibleDevices: [] })),
    }),
    {
      name: storeNames.bargeControl,
      storage: createJSONStorage(() => localStorage),
    }
  )
);
